import { registrationState } from '../state/registrationState'
import {
    FETCH_HEARTRUNNER_ORG_REQUEST, FETCH_HEARTRUNNER_ORG_SUCCESS, FETCH_HEARTRUNNER_ORG_ERROR ,
    INSERT_HEARTRUNNER_REGISTER_REQUEST, INSERT_HEARTRUNNER_REGISTER_SUCCESS, INSERT_HEARTRUNNER_REGISTER_ERROR 
    

} from '../actions/registrationAction'


export function heartRunnerRegistrationReducer(state = registrationState, action) {
    switch (action.type) {
        case FETCH_HEARTRUNNER_ORG_REQUEST:
            return Object.assign({}, state, {
                
                isLoading: action.isLoading
            })
        case FETCH_HEARTRUNNER_ORG_SUCCESS:
            
            return Object.assign({}, state, {
                heartRunnerOrgInfo:action.heartRunnerOrgInfo,
                isLoading: action.isLoading,
                Message: action.Message,
            })
        case INSERT_HEARTRUNNER_REGISTER_REQUEST:
                return Object.assign({}, state, {
                    
                    isLoading: action.isLoading
                })
        case INSERT_HEARTRUNNER_REGISTER_SUCCESS:
            
            return Object.assign({}, state, {
                //heartRunnerOrgInfo:action.heartRunnerOrgInfo,
                statusCode:action.statusCode,
                isLoading: action.isLoading,
                Message: action.Message,
            })
        case INSERT_HEARTRUNNER_REGISTER_ERROR:
                
                return Object.assign({}, state, {
                    //heartRunnerOrgInfo:action.heartRunnerOrgInfo,
                    statusCode:action.statusCode,
                    isLoading: action.isLoading,
                    Message: action.data.Message,
                })
       
        default:
            return state;
    }
} 